import React, { useState, useEffect } from "react";
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import MDInput from "components/MDInput";
import { useSelector, useDispatch } from "react-redux";
import { fetchThingDetails } from "features/thing/thingThunk";
import { fetchAlertConfigDetails } from "features/alert/alertThunk";
import axios from "axios";
import { setToggle, setVehicleSearch, setSelectedAlert } from "features/alert/alertSlice";
import { setRefresh } from "features/geoFence/geoFenceSlice";
import { getAlertDetails } from "config/apis";
// import { setSelectedAlert } from "features/alert/alertSlice";

function FilterCard() {
  const [vehicleStatus, setVehicleStatus] = useState("enabled");
  const [alertType, setAlertType] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [alertTypes, setAlertTypes] = useState([]);

  const dispatch = useDispatch();
  const alertData = useSelector((state) => state.alerts.data);
  const things = useSelector((state) => state.things.filterThing || []);
  const vehicleOptions = things.map((thing) => ({
    label: thing.name || `Vehicle ${thing.id}`,
    value: thing.id,
  }));

  useEffect(() => {
    dispatch(fetchThingDetails());
  }, [dispatch]);

  useEffect(() => {
    const fetchAlertTypes = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(getAlertDetails, {
          headers: {
            "x-dhundhoo-session": token,
          },
        });

        const data = response.data.responseData;
        console.log(data, "data");

        if (Array.isArray(data)) {
          setAlertTypes(data);
        } else if (data?.alerts) {
          setAlertTypes(data.alerts);
        } else {
          console.warn("Unexpected API format", data);
        }
      } catch (error) {
        console.error("Error fetching alert types:", error);
      }
    };

    fetchAlertTypes();
  }, []);

  const handleType = async (type) => {
    console.log("type", type);

    dispatch(setSelectedAlert(type));
    await dispatch(fetchAlertConfigDetails(type.alertId));
  };
  const handleAlert = (e) => {
    setVehicleStatus(e.target.value);
    e.target.value == "enabled"
      ? dispatch(setToggle(true))
      : dispatch(setToggle(false));
    dispatch(setRefresh());
    const selectedType = alertTypes.find(
      (type) => type.alertName === alertType
    );

    if (selectedType?.alertId) {
      dispatch(fetchAlertConfigDetails(Number(selectedType.alertId)));
    }
  };
  const handleSearch = (newValue) => {
    setSelectedVehicle(newValue);
    dispatch(setVehicleSearch(newValue));
  };

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, p: 2, maxWidth: "100%" }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Filter Alerts
        </Typography>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
            gap: 3,
            alignItems: "center",
          }}
        >
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Alert Type</InputLabel>
            <Select
              value={alertType}
              // onChange={(e) => setAlertType(e.target.value)}
              onChange={(e) => {
                const selectedName = e.target.value;
                setAlertType(selectedName);

                const selectedType = alertTypes.find(
                  (type) => type.alertName === selectedName
                );

                if (selectedType) {
                  handleType(selectedType);
                }
              }}

              label="Alert Type"
              style={{ padding: "8px 0px 8px 0px" }}
            >
              {alertTypes.length > 0 ? (
                alertTypes.map((type, index) => (
                  // <MenuItem
                  //   key={index}
                  //   value={type.alertName}
                  //   onClick={() => handleType(type)}
                  // >
                  <MenuItem
  key={index}
  value={type.alertName}
>

                    {type.alertName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Loading...</MenuItem>
              )}
            </Select>
          </FormControl>

          <FormControl component="fieldset">
            <RadioGroup
              row
              value={vehicleStatus}
              onChange={(e) => handleAlert(e)}
              name="vehicle-status"
            >
              <FormControlLabel
                value="enabled"
                control={<Radio />}
                label="Enabled"
              />
              <FormControlLabel
                value="disabled"
                control={<Radio />}
                label="Disabled"
              />
            </RadioGroup>
          </FormControl>
          <Autocomplete
            options={vehicleOptions}
            value={selectedVehicle}
            onChange={(event, newValue) => {
              handleSearch(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            renderInput={(params) => (
              <MDInput
                {...params}
                label="Search Vehicle"
                placeholder="Enter vehicle ID or name"
                fullWidth
                size="small"
              />
            )}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default FilterCard;
